"use strict";
export const mockLendingProposals = [
  {
    id: "1",
    chainId: 8453,
    tokenAAllowList: ["0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"],
    tokenBAllowList: ["0x4200000000000000000000000000000000000006"],
    creditAmount: 5e9,
    creditAsset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
      decimals: 6,
      name: "USD Coin",
      chainId: 8453,
      logoUrl: "https://imgs.search.brave.com/qVfnM06301I6nmM20XJwh7E1dtjKpAU1IA0dllgkXNo/rs:fit:40:40:1:0/g:ce/aHR0cHM6Ly9jb2lu/LWltYWdlcy5jb2lu/Z2Vja28uY29tL2Nv/aW5zL2ltYWdlcy82/MzE5L2xhcmdlL3Vz/ZGMucG5nPzE2OTY1/MDY2OTQ"
    },
    loanToValue: 7e4,
    expiration: 1747519200,
    apr: 7842,
    proposer: "0x1234567890123456789012345678901234567890",
    hash: "0x779c04dab366992bfa2f4f08434df8593e1ecbb0044aa523f34cde64f4426329"
  },
  {
    id: "2",
    chainId: 8453,
    tokenAAllowList: ["0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"],
    tokenBAllowList: ["0x4200000000000000000000000000000000000006"],
    creditAmount: 2452e6,
    creditAsset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
      decimals: 6,
      name: "USD Coin",
      chainId: 8453,
      logoUrl: "https://imgs.search.brave.com/qVfnM06301I6nmM20XJwh7E1dtjKpAU1IA0dllgkXNo/rs:fit:40:40:1:0/g:ce/aHR0cHM6Ly9jb2lu/LWltYWdlcy5jb2lu/Z2Vja28uY29tL2Nv/aW5zL2ltYWdlcy82/MzE5L2xhcmdlL3Vz/ZGMucG5nPzE2OTY1/MDY2OTQ"
    },
    loanToValue: 75e3,
    expiration: 1747519200,
    apr: 8242,
    proposer: "0x1234567890123456789012345678901234567890",
    hash: "0x779c04dab366992bfa2f4f08434df8593e1ecbb0044aa523f34cde64f4426329"
  },
  {
    id: "3",
    chainId: 8453,
    tokenAAllowList: ["0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"],
    tokenBAllowList: ["0x4200000000000000000000000000000000000006"],
    creditAmount: 1e10,
    creditAsset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
      decimals: 6,
      name: "USD Coin",
      chainId: 8453,
      logoUrl: "https://imgs.search.brave.com/qVfnM06301I6nmM20XJwh7E1dtjKpAU1IA0dllgkXNo/rs:fit:40:40:1:0/g:ce/aHR0cHM6Ly9jb2lu/LWltYWdlcy5jb2lu/Z2Vja28uY29tL2Nv/aW5zL2ltYWdlcy82/MzE5L2xhcmdlL3Vz/ZGMucG5nPzE2OTY1/MDY2OTQ"
    },
    loanToValue: 65e3,
    expiration: 1748519200,
    apr: 6842,
    proposer: "0x1234567890123456789012345678901234567890",
    hash: "0x779c04dab366992bfa2f4f08434df8593e1ecbb0044aa523f34cde64f4426329"
  },
  {
    id: "4",
    chainId: 8453,
    tokenAAllowList: ["0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"],
    tokenBAllowList: ["0x4200000000000000000000000000000000000006"],
    creditAmount: 75e8,
    creditAsset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
      decimals: 6,
      name: "USD Coin",
      chainId: 8453,
      logoUrl: "https://imgs.search.brave.com/qVfnM06301I6nmM20XJwh7E1dtjKpAU1IA0dllgkXNo/rs:fit:40:40:1:0/g:ce/aHR0cHM6Ly9jb2lu/LWltYWdlcy5jb2lu/Z2Vja28uY29tL2Nv/aW5zL2ltYWdlcy82/MzE5L2xhcmdlL3Vz/ZGMucG5nPzE2OTY1/MDY2OTQ"
    },
    loanToValue: 8e4,
    expiration: 1746519200,
    apr: 9242,
    proposer: "0x1234567890123456789012345678901234567890",
    hash: "0x779c04dab366992bfa2f4f08434df8593e1ecbb0044aa523f34cde64f4426329"
  },
  {
    id: "5",
    chainId: 8453,
    tokenAAllowList: ["0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"],
    tokenBAllowList: ["0x4200000000000000000000000000000000000006"],
    creditAmount: 375e7,
    creditAsset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
      decimals: 6,
      name: "USD Coin",
      chainId: 8453,
      logoUrl: "https://imgs.search.brave.com/qVfnM06301I6nmM20XJwh7E1dtjKpAU1IA0dllgkXNo/rs:fit:40:40:1:0/g:ce/aHR0cHM6Ly9jb2lu/LWltYWdlcy5jb2lu/Z2Vja28uY29tL2Nv/aW5zL2ltYWdlcy82/MzE5L2xhcmdlL3Vz/ZGMucG5nPzE2OTY1/MDY2OTQ"
    },
    loanToValue: 72500,
    expiration: 1745519200,
    apr: 8042,
    proposer: "0x1234567890123456789012345678901234567890",
    hash: "0x779c04dab366992bfa2f4f08434df8593e1ecbb0044aa523f34cde64f4426329"
  },
  {
    id: "6",
    chainId: 8453,
    tokenAAllowList: ["0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"],
    tokenBAllowList: ["0x4200000000000000000000000000000000000006"],
    creditAmount: 15e9,
    creditAsset: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "USDC",
      decimals: 6,
      name: "USD Coin",
      chainId: 8453,
      logoUrl: "https://imgs.search.brave.com/qVfnM06301I6nmM20XJwh7E1dtjKpAU1IA0dllgkXNo/rs:fit:40:40:1:0/g:ce/aHR0cHM6Ly9jb2lu/LWltYWdlcy5jb2lu/Z2Vja28uY29tL2Nv/aW5zL2ltYWdlcy82/MzE5L2xhcmdlL3Vz/ZGMucG5nPzE2OTY1/MDY2OTQ"
    },
    loanToValue: 67500,
    expiration: 1749519200,
    apr: 7542,
    proposer: "0x1234567890123456789012345678901234567890",
    hash: "0x779c04dab366992bfa2f4f08434df8593e1ecbb0044aa523f34cde64f4426329"
  }
];
